// Constants
export const CARRY_ON = 'CARRY_ON'
export const CHECK_IN = 'CHECK_IN'
export const SEAT = 'SEAT'
export const MEAL = 'MEAL'
export const BAGGAGE_BENEFIT_KEYS = [CARRY_ON, CHECK_IN] as const
export const OTHER_BENEFIT_KEYS = [SEAT] as const
export const ELIGIBLE_BENEFITS = [...BAGGAGE_BENEFIT_KEYS, ...OTHER_BENEFIT_KEYS] as const

export const AMEND = 'AMEND'
export const CANCEL = 'CANCEL'
export const ALLOWED = 'ALLOWED'
export const NOT_ALLOWED = 'NOT_ALLOWED'
